import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styles: [],
  standalone: false,
})
export class PaymentComponent {
  constructor(private router: Router) {}

  goToApp() {
    location.href = "myapp://app.estetistapp.it";
  }
}
